import AddNewControlReadOnlyText from './AddNewControlReadOnlyText';
import ControlReadOnlyTextEngine from './ControlReadOnlyTextEngine';
import ControlReadOnlyTextEntry from './ControlReadOnlyTextEntry';
import getLatestSchema from './schema';
import getYupSchemaForReadOnlyTextEngine from './getYupSchemaForReadOnlyTextEngine';
import translator from './translator';
import { ControlConfig } from '../controlConfig';
import ControlReadOnlyTextPlaceholder from './ControlReadOnlyTextPlaceholder';

export default {
  getDefaultValue: () => ({}),
  getLatestSchema,
  Engine: ControlReadOnlyTextEngine,
  Entry: ControlReadOnlyTextEntry,
  Add: AddNewControlReadOnlyText,
  yupSchemaEngine: getYupSchemaForReadOnlyTextEngine,
  yupSchemaEntry: () => ({}),
  translator,
  Placeholder: ControlReadOnlyTextPlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
